import { Controller } from "@hotwired/stimulus"
import { addClass, removeClass } from "utils/toggle_class"
import { updateSlimSelectValue } from "controllers/dropdown_controller"

// Inspired by https://codepen.io/webcrunchblog/pen/YOZQXP
export default class extends Controller {
  static targets = ["tab", "tabContent", "tabDropdown"]

  tabClick(event) {
    event.preventDefault()

    if (this.hasTabDropdownTarget) {
      // Update the dropdown, which will trigger the rest of the updates, including updating the desktop version.
      // This way, mobile and desktop states are kept consistent.
      updateSlimSelectValue(this.tabDropdownTarget, event.target.getAttribute("href"))
    } else {
      const $newTab = event.target.closest("li")
      this._deactiveateTab(this._activeTab())
      this._activateTab($newTab)
    }
  }

  tabDropdown(event) {
    const contentHref = event.target.value

    if (contentHref[0] !== "#") {
      window.location.href = contentHref
    } else {
      // Hide and show content
      this._deactiveateTabContent(this._activeContentHref())
      this._activateTabContent(contentHref)

      // Update desktop tabs
      const newTab = Array.from(this.tabTargets).find((tab) => tab.querySelector(`[href="${contentHref}"]`))
      this._deactiveateTab(this._activeTab())
      this._activateTab(newTab)
    }
  }

  _activateTab($tab) {
    if ($tab === undefined) return

    addClass($tab, "active")
    $tab.dispatchEvent(new CustomEvent("qb.tab.switch", { bubbles: true }))
    const tabLink = $tab.querySelector("a")

    tabLink.setAttribute("aria-selected", true)

    this._activateTabContent(tabLink.href)
  }

  _activateTabContent(contentHref) {
    const $associatedTabContent = this._associatedTabContent(contentHref)
    addClass($associatedTabContent, "active")
    $associatedTabContent.setAttribute("aria-expanded", true)
    $associatedTabContent.setAttribute("hidden", false)
  }

  _deactiveateTab($tab) {
    if ($tab === undefined) return

    removeClass($tab, "active")
    const tabLink = $tab.querySelector("a")
    tabLink.setAttribute("aria-selected", false)

    this._deactiveateTabContent(tabLink.href)
  }

  _deactiveateTabContent(contentHref) {
    const $associatedTabContent = this._associatedTabContent(contentHref)
    removeClass($associatedTabContent, "active")
    $associatedTabContent.setAttribute("aria-expanded", false)
    $associatedTabContent.setAttribute("hidden", true)
  }

  _associatedTabContent(contentHref) {
    const contentId = contentHref.split("#")[1]
    return this.tabContentTargets.find(($content) => $content.id === contentId)
  }

  _activeTab() {
    return Array.from(this.tabTargets).find((tab) => tab.classList.contains("active"))
  }

  _activeContentHref() {
    const contentElement = Array.from(this.tabContentTargets).find((tabContents) => tabContents.classList.contains("active"))
    return `#${contentElement.id}`
  }
}
